onDomLoad(($dom) => {
  $dom.find("[data-behaviour='report-template-removal']").each((_index, el) => {
    el.addEventListener('click', (event) => {
      event.preventDefault()
      event.stopPropagation()

      const modalParams = {
        templateName: event.currentTarget.dataset.templateName,
        url: event.currentTarget.href,
        eligible: event.currentTarget.dataset.eligible === 'true',
      }
      window.modalCitizen.openModal(
        'report-template-removal-modal',
        modalParams
      )
    })
  })
})
